module.exports = __webpack_public_path__ + "static/media/event_approval_status_white.cb15da35.svg";